"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ButtonOption;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _context = require("../ButtonGroupPicker/context");

var _hiddenElement = _interopRequireDefault(require("../Structural/hiddenElement"));

var _styled = require("./styled");

var _isOptionSelected = _interopRequireDefault(require("./helpers/isOptionSelected"));

var _hooks = require("../../libs/hooks");
/**
 * @category Form
 */


function ButtonOption(props) {
  var inputId = (0, _hooks.useUniqueIdentifier)('button-option');
  var className = props.className,
      style = props.style,
      name = props.name,
      label = props.label,
      disabled = props.disabled,
      onClick = props.onClick;

  var _useContext = (0, _react.useContext)(_context.ButtonGroupPickerContext),
      type = _useContext.type,
      values = _useContext.values,
      contextName = _useContext.name,
      onChange = _useContext.onChange,
      ariaDescribedBy = _useContext.ariaDescribedBy,
      size = _useContext.size,
      variant = _useContext.variant;

  var checked = (0, _isOptionSelected["default"])(values, name);

  var handleClick = function handleClick() {
    return onClick({
      isSelected: checked
    });
  };

  var isShaded = variant === 'shaded';
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledLabel, {
    className: className,
    style: style,
    onClick: handleClick,
    checked: checked,
    htmlFor: inputId,
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement(_hiddenElement["default"], {
    id: inputId,
    as: "input",
    type: type,
    name: contextName,
    value: name,
    "aria-describedby": ariaDescribedBy,
    checked: checked,
    onChange: onChange,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(_styled.StyledText, {
    size: size,
    disabled: disabled,
    checked: checked,
    variant: variant
  }, label), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: isShaded
  }, /*#__PURE__*/_react["default"].createElement(_styled.StyledDivider, null)));
}

ButtonOption.propTypes = {
  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with a custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** It is a unique value that identifies the picker option. */
  name: _propTypes["default"].string,

  /** The content to be displayed inside the ButtonOption */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** Specifies whether this button should be displayed in a disabled state. Disabled buttons can't be clicked. */
  disabled: _propTypes["default"].bool,

  /** The action triggered when the element is clicked. */
  onClick: _propTypes["default"].func
};
ButtonOption.defaultProps = {
  className: undefined,
  style: undefined,
  name: undefined,
  label: undefined,
  disabled: false,
  onClick: function onClick() {}
};